<button
  type="button"
  class="ipm-daterange-trigger"
  [class.open]="isOpen"
  (click)="openDialog()">
  <svg class="trigger-icon" width="15" height="15" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  </svg>
  <span class="trigger-label">{{ triggerLabel }}</span>
  <i class="pi pi-chevron-down trigger-chevron" [class.open]="isOpen"></i>
</button>

<!-- Rendered inside the app's standard MatDialog (ipm-custom-mat-dialog). -->
<ng-template #dialogTemplate>
  <div class="ipm-daterange-dialog-content">
    <div class="ipm-heading-section">
      <h3>Select date range</h3>
      <!-- <div class="ipm-close-icon" (click)="closeDialog()">
        <i class="pi pi-times"></i>
      </div> -->
    </div>

    <!-- Mobile only: presets collapse into a dropdown. Kept outside the bordered
         body (which clips overflow) so its panel renders inline, attached to the
         trigger, and within the dialog/bottom-sheet stacking context. -->
    <div class="presets-dropdown-wrap">
      <p-dropdown
        [options]="presets"
        [(ngModel)]="draftKey"
        [ngModelOptions]="{ standalone: true }"
        (onChange)="selectPresetByKey($event.value)"
        optionLabel="label"
        optionValue="key"
        [autofocus]="false"
        placeholder="Custom range"
        panelStyleClass="ipm-daterange-dropdown-panel"
        [className]="'ipm-dropdown'">
      </p-dropdown>
    </div>

    <div class="ipm-daterange-body">
      <!-- Desktop: preset shortcut list. -->
      <div class="presets">
        <button
          type="button"
          *ngFor="let preset of presets"
          class="preset-item"
          [class.active]="preset.key === draftKey"
          (click)="selectPreset(preset)">
          {{ preset.label }}
        </button>
      </div>

      <div class="calendar-wrap">
        <mat-calendar
          [maxDate]="maxDate"
          [startAt]="draftRange.start"
          [selected]="draftRange"
          (selectedChange)="onCalendarChange($event)">
        </mat-calendar>
      </div>
    </div>

    <div class="panel-footer">
      <span class="range-readout">{{ draftReadout }}</span>
      <div class="actions">
        <button type="button" class="btn-cancel" (click)="cancel()">Cancel</button>
        <button
          type="button"
          class="btn-apply"
          [disabled]="!draftRange.start || !draftRange.end"
          (click)="apply()">
          Apply
        </button>
      </div>
    </div>
  </div>
</ng-template>
